module.exports = function() {
  return new Worker(__webpack_public_path__ + "exr.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js?name=exr.worker.js!./build_npm/utils/exr-parser.worker.js
// module id = 17
// module chunks = 0 1